import { useEffect, useState } from 'react';

/**
 * useDebouncedValue — renvoie `value` après `delay` ms sans nouveau changement.
 *
 * Sert à découpler la frappe du calcul : l'input reste piloté par son état
 * immédiat (aucune latence ressentie à la saisie), tandis que la recherche
 * ne tourne qu'une fois la rafale terminée.
 *
 * Le tracking GA4 de SearchBox était déjà débouncé ; la RECHERCHE elle-même ne
 * l'était pas — chaque caractère déclenchait le calcul complet.
 */
export default function useDebouncedValue(value, delay = 120) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
